import styles from "./resetpasswordblock2.module.css";
import InputOTP from "../InputOTP";
import { useTranslation } from "react-i18next";
import ConfirmButton from "../ConfirmButton";
import { useState } from "react";

export default function ResetPasswordBlock2() {
  const { t } = useTranslation();
  const [otpValue, setOtpValue] = useState("");
  return (
    <div className={styles.resetpassBlock}>
      <h2 className={styles.resetText}>{t("enter_otp")}</h2>
      <div className={`col-11 ${styles.inputBlock}`}>
        <div className={`col-11 ${styles.inputContainer}`}>
          <InputOTP otpValue={otpValue} setOtpValue={setOtpValue} />
        </div>
      </div>
      <div className={`col-12 ${styles.confirmButtonContainer}`}>
        <ConfirmButton otpValue={otpValue} navigateTo={"?s=3"}/>
      </div>
      <p className={styles.tosignupPage}>
        {t("first_time_bhive")} <a href="signup">{t("signup")}</a>
      </p>
    </div>
  );
}
